/* eslint-disable no-redeclare */
import { z } from 'zod';

export const LifestyleActivities = z.enum(['YES', 'NO']);

export type LifestyleActivities = z.infer<typeof LifestyleActivities>;
